import React, { useEffect, useRef, useState } from "react";
import { Alert, Button, Col, Form, Modal, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import Select from 'react-select';
import * as manualOrdersCrud from './manualOrdersCrud'
import * as helpersCrud from '../Sales/_redux/helpers/helpersCrud'
import { business_unit_options, isValidEmail, motive_options, payment_method_options, shipping_method_options } from "./NewOrderDialog";



export function EditOrderDialog({ show, onHide, onSave, manualOrderForEdit, readOnly = false }) {
    const [loadingProductos, setLoadingProductos] = useState(false);
    const [error, setError] = useState({});
    const [lineItems, setLineItems] = useState([]);
    const [manualOrder, setManualOrder] = useState({})
    const ref = useRef();
    // Opciones para los selects (se cargan del backend)
    const [products, setProducts] = useState([]);
    const [states, setStates] = useState([]);
    const [localities, setLocalities] = useState([]);

    // Estado temporal para agregar producto
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [productQuantity, setProductQuantity] = useState(1);


    const fetchData = async()=>{
        let _order = null;
        let _states = await helpersCrud.getStates();
        let _localities= null;

        if(_states?.data?.results){
            _states = _states.data.results.map(s=>({...s, label:s.name, value:s.id}))
            setStates(_states)

            _order = await manualOrdersCrud.getManualOrderById(manualOrderForEdit.id)
            _order = _order.data
            if(_order){
                const _stateId = _states.find(s=>s.name==_order.shipping_country)?.id
                if(_stateId){
                    _localities = await helpersCrud.getLocalities({filter:{state_id:_stateId}});
                    if(_localities?.data?.results){
                        _localities = _localities.data.results.map(s=>({...s, label:s.name, value:s.id}))
                        setLocalities(_localities)
                    }
                }

                setManualOrder({
                    ..._order,
                    payment_method: payment_method_options.find(p=> +p.value == +_order.payment_method_id) || null,
                    state: _states?.find(p=> p.label == _order.shipping_country) || null,
                    locality: _localities?.find(p=> p.label == _order.shipping_city) || null,
                    shipping_method: shipping_method_options.find(p=>p.label==_order.shipping_method_title) || null,
                    first_name: _order.shipping_first_name || '',
                    last_name: _order.shipping_last_name || '',
                    email: _order.shipping_email || '',
                    address_1: _order.shipping_address_1 || '',
                    billing_dni: _order.billing_dni || '',
                    motive: motive_options.find(m=>m.value==_order.motive) || motive_options[0],
                    business_unit: business_unit_options.find(m=>m.value==_order.business_unit_id) || business_unit_options[0]
                })
                setLineItems(_order.detail)
            }
        }
    }

    const handleSearch = async(query) => {
        try{
            setLoadingProductos(true);    
            const op = await manualOrdersCrud.getAllProducts({ filter:{text:query, source_id: manualOrder.business_unit?.value}})
            if(op && op.data && op.data.results)
                setProducts(op.data.results)
            else
                setProducts([])
            setLoadingProductos(false)
    
        }
        catch(err){
            console.log(err)
            setLoadingProductos(false)

        }
    };
    const onChangeProduct = (value)=>{
        setSelectedProduct(value[0])
    }

    const filteredProducts = products.filter( p => !lineItems.some(s => +s.product_id == +p.origin_id) );

    const loadCountries = async () => {
        // TODO: llamar al backend
        // const response = await getCountries();
        // setCountries(response.data.map(c => ({ value: c.code, label: c.name })));
    };

    const loadLocalities = async (stateId) => {
        let resp = await helpersCrud.getLocalities({filter:{state_id:stateId}});
        if(resp?.data?.results){
            const _locality = resp.data.results.map(s=>({...s, label:s.name, value:s.id}))
            setLocalities(_locality)
        }
    };

    const handleStateChange = (option) => {
        setManualOrder({ 
            ...manualOrder, 
            state: option, 
            locality: null 
        });
        if (option?.value) {
            loadLocalities(option.value);
        } else {
            setLocalities([]);
        }
    };

    const handleAddProduct = () => {
        if (!selectedProduct || productQuantity < 1) return;

        const newItem = {
            product_id: selectedProduct.origin_id,
            product_name: selectedProduct.name,
            quantity: productQuantity,
            price: ''
        };
        ref.current.clear()
        setLineItems([...lineItems, newItem]);
        setSelectedProduct(null);
        setProducts([])
        setProductQuantity(1);
    };

    const handleRemoveProduct = (index) => {
        setLineItems(lineItems.filter((_, i) => i !== index));
    };
    const handlePriceChange = (index, value) => {
        if (value !== '' && !/^\d*\.?\d{0,2}$/.test(value)) return; // bloquea letras/negativos/inválidos
        setLineItems(lineItems.map((item, i) => i === index ? { ...item, price: value } : item));
    };
    const handleEditProduct = (index) => {
        setLineItems(lineItems.filter((_, i) => i !== index));
    };
    const handleShippingMethodChange = (option) => {
        setManualOrder({
            ...manualOrder,
            shipping_method:option,
            costo_envio: option.value==3 ? 0 : manualOrder.costo_envio // farmacia costo 0
        });
    };
    const handlePaymentMethodChange = (option) => {
        setManualOrder({
            ...manualOrder,
            payment_method: option
        });
    };
    const handleShippingCostChange = (e) => {
        setManualOrder({ ...manualOrder, shipping_cost: e.target.value })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (readOnly) return;
        let _error = {}

        if(!isValidEmail(manualOrder?.email)){
            _error.email=true
        }
        else{
            _error.email=false
        }
        // if(manualOrder.shipping_cost && manualOrder.shipping_cost.trim()!=''){
        //     if(isNaN(manualOrder.shipping_cost)){
        //         _error.shipping_cost=true
        //     }
        //     else{
        //         _error.shipping_cost=false
        //     }
        // }

        if(_error.email) { // || _error.shipping_cost){
            setError(_error)
            return
        }

        if(lineItems<=0){
            setError({...error, detalle: true})
            return
        }

        const faltaPrecio = lineItems.some(
            item => item.price === '' || item.price === null || item.price === undefined
        );
        if (faltaPrecio) {
            setError({ ...error, precio: true });
            return;
        }

        const orderData = {
            id: manualOrder.id,
            payment_method_id: manualOrder.payment_method?.value ,
            payment_method_title: manualOrder.payment_method?.label ,
            billing_dni: manualOrder.billing_dni,
            shipping_first_name: manualOrder.first_name,
            shipping_last_name: manualOrder.last_name,
            shipping_address_1: manualOrder.address_1,
            shipping_city: manualOrder.locality?.name,
            shipping_country: manualOrder.state?.name ,
            shipping_method_id: manualOrder.shipping_method?.method_id ,
            shipping_method_title: manualOrder.shipping_method?.label ,
            shipping_total: 0 ,
            shipping_email: manualOrder.email ,
            shipping_postcode: manualOrder.shipping_postcode ,
            set_paid: false,
            business_unit_id: manualOrder.business_unit?.value, 
            motive: manualOrder.motive?.value,
            observations: manualOrder.observations,
            line_items: lineItems.map(item => ({
                product_id: item.product_id,
                quantity: item.quantity,
                price: Number(item.price) || 0
            })),
        };


        onSave(orderData);

    };


    useEffect(() => {
        if (show) {
            setError({})
            fetchData();
        }
    }, [show]);


    return (
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="new-order-modal"
            size="xl"
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title id="new-order-modal">
                    {readOnly ? `Ver Pedido Manual #${manualOrderForEdit?.id || ''}` : 'Nuevo Pedido Manual'}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>

                {error?.detalle && (
                    <Alert variant="danger" onClose={() => setError({})} dismissible>
                        {"Debe seleccionar al menos un artículo"}
                    </Alert>
                )}
                {error?.precio && (
                    <Alert variant="danger" onClose={() => setError({})} dismissible>
                        {"Debe cargar el precio de todos los artículos"}
                    </Alert>
                )}
                <Form onSubmit={handleSubmit} noValidate>
                    <Row>
                        <Col md={3}>
                            <Form.Group>
                                <Form.Label>Unidad de negocio</Form.Label>
                                <Select
                                    options={business_unit_options}
                                    onChange={ev=>setManualOrder({...manualOrder, business_unit:ev})}
                                    value={manualOrder.business_unit || business_unit_options[0]}
                                    placeholder=""
                                    isDisabled={true}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group>
                                <Form.Label>Motivo del pedido</Form.Label>
                                <Select
                                    options={motive_options}
                                    onChange={ev=>setManualOrder({...manualOrder, motive:ev})}
                                    value={manualOrder.motive || motive_options[0]}
                                    placeholder=""
                                    isDisabled={readOnly}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Nombre</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={manualOrder.first_name}
                                    onChange={(e) => setManualOrder({ ...manualOrder, first_name: e.target.value })}
                                    disabled={readOnly}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Apellido</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={manualOrder.last_name}
                                    onChange={(e) => setManualOrder({ ...manualOrder, last_name: e.target.value })}
                                    disabled={readOnly}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    className={`${error?.email ? "border border-danger" : ""}`}
                                    type="text"
                                    value={manualOrder.email || ""}
                                    onChange={(e) => {
                                        setError({...error, email:false})
                                        setManualOrder({ ...manualOrder, email: e.target.value })}
                                    }
                                    disabled={readOnly}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>DNI</Form.Label>
                                <Form.Control
                                    className={`${error?.billing_dni ? "border border-danger" : ""}`}
                                    type="text"
                                    value={manualOrder.billing_dni || ""}
                                    onChange={(e) => {
                                        setError({...error, billing_dni:false})
                                        setManualOrder({ ...manualOrder, billing_dni: e.target.value })}
                                    }
                                    disabled={readOnly}
                                />
                            </Form.Group>
                        </Col>
                    </Row>                    
                    {/* DATOS DE DOMICILIO */}
                    <h6 className="font-weight-bold mb-3">Datos de domicilio</h6>
                    <Row>
                        <Col md={12}>
                            <Form.Group>
                                <Form.Label>Dirección</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={manualOrder.address_1}
                                    onChange={(e) => setManualOrder({ ...manualOrder, address_1: e.target.value })}
                                    disabled={readOnly}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={5}>
                            <Form.Group>
                                <Form.Label>Provincia</Form.Label>
                                <Select
                                    options={states}
                                    onChange={handleStateChange}
                                    value={manualOrder.state || null}
                                    placeholder="Seleccionar país..."
                                    isClearable
                                    isDisabled={readOnly}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={5}>
                            <Form.Group>
                                <Form.Label>Localidad</Form.Label>
                                <Select
                                    options={localities}
                                    onChange={(option) => setManualOrder({ ...manualOrder, locality: option })}
                                    value={manualOrder.locality || null}
                                    placeholder="Seleccionar localidad..."
                                    isClearable
                                    isDisabled={readOnly || !manualOrder.state}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={2}>
                            <Form.Group>
                                <Form.Label>CP</Form.Label>
                                <Form.Control
                                    maxLength={4}
                                    type="text"
                                    value={manualOrder.shipping_postcode}
                                    onChange={(e) => setManualOrder({ ...manualOrder, shipping_postcode: e.target.value })}
                                    disabled={readOnly}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {/* ENVÍO Y PAGO */}
                    {/* <h6 className="font-weight-bold mb-3">Envío y Pago</h6> */}
                    <h6 className="font-weight-bold mb-3">Envío</h6>
                    <Row>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Método de Envío</Form.Label>
                                <Select
                                    options={shipping_method_options}
                                    onChange={handleShippingMethodChange}
                                    value={ manualOrder.shipping_method || null}
                                    placeholder="Seleccionar..."
                                    isClearable
                                    isDisabled={readOnly}
                                />
                            </Form.Group>
                        </Col>
                        {/* <Col md={4}>
                            <Form.Group>
                                <Form.Label>Método de Pago</Form.Label>
                                <Select
                                    options={payment_method_options}
                                    onChange={handlePaymentMethodChange}
                                    value={manualOrder.payment_method || null}
                                    placeholder="Seleccionar..."
                                    isClearable
                                />
                            </Form.Group>
                        </Col> */}
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Observaciones</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={manualOrder.observations || ""}
                                    onChange={(e) => {
                                        setManualOrder({ ...manualOrder, observations: e.target.value })}
                                    }
                                    disabled={readOnly}
                                />
                            </Form.Group>
                        </Col>
                    </Row> 

                    {/* PRODUCTOS */}
                    <h6 className="font-weight-bold mb-3">Productos</h6>
                    {!readOnly &&
                    <Row className="align-items-end">
                        <Col md={6}>
                            <Form.Group>
                                <AsyncTypeahead
                                    id="buscadorProductos"
                                    ref={ref}
                                    className='mr-6'
                                    highlightOnlyResult={false}
                                    renderMenuItemChildren={(option) => (
                                            <span>{option.name}</span>
                                        )}
                                    isLoading={loadingProductos}
                                    minLength={3}
                                    labelKey={option => `${option.name}`}
                                    onSearch={handleSearch}
                                    options={filteredProducts}
                                    filterBy={['name', 'sku']}
                                    prompText='Escribe para buscar productos'
                                    searchText='Buscando...'
                                    placeholder='Escribe para buscar productos'
                                    onChange={onChangeProduct}
                                    useCache={false}
                                />
                            </Form.Group>
                            {/* <Form.Group>
                                <Form.Label>Producto</Form.Label>
                                <Select
                                    options={products}
                                    onChange={setSelectedProduct}
                                    value={selectedProduct}
                                    placeholder="Buscar producto..."
                                    isClearable
                                />
                            </Form.Group> */}
                        </Col>
                        <Col md={3}>
                            <Form.Group>
                                <Form.Label>Cantidad</Form.Label>
                                <Form.Control
                                    type="number"
                                    min="1"
                                    value={productQuantity}
                                    onChange={(e) => setProductQuantity(parseInt(e.target.value) || 1)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group>
                                <Button
                                    variant="success"
                                    onClick={handleAddProduct}
                                    disabled={!selectedProduct}
                                    className="w-100"
                                >
                                    Agregar
                                </Button>
                            </Form.Group>
                        </Col>
                    </Row>
                    }

                    {lineItems.length > 0 && (
                        <Table size="sm" className="table table-head-custom table-vertical-center overflow-hidden">
                            <thead>
                                <tr>
                                    <th>Producto</th>
                                    <th style={{ width: '100px' }}>Cantidad</th>
                                    <th style={{ width: '150px' }}>Precio unitario</th>
                                    <th style={{ width: '120px' }}>Subtotal</th>
                                    <th style={{ width: '120px' }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {lineItems.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.product_name}</td>
                                        <td>{item.quantity}</td>
                                        <td>
                                            <Form.Control
                                                type="text"
                                                inputMode="decimal"
                                                placeholder="0.00"
                                                className={error?.precio && (item.price === '' || item.price == null) ? "border border-danger" : ""}
                                                value={item.price ?? ''}
                                                onChange={(e) => handlePriceChange(index, e.target.value)}
                                                disabled={readOnly}
                                            />
                                        </td>
                                        <td>{((Number(item.price) || 0) * item.quantity).toFixed(2)}</td>
                                        <td className="text-center">
                                            {/* <Button className="btn btn-icon btn-light btn-hover-primary btn-sm mr-2" 
                                                onClick={() => handleEditProduct(index)} >
                                                <span><i className="fas fa-edit text-primary"></i></span>
                                            </Button> */}            
                                            {!readOnly &&
                                            <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-${index}`}>{`Eliminar ${item.product_name} del pedido`}</Tooltip>}>
                                                <span>
                                                    <Button className="btn btn-icon btn-light btn-hover-danger btn-sm mr-2"
                                                        onClick={() => handleRemoveProduct(index)} >
                                                        <span><i className="fas fa-trash text-danger"></i></span>
                                                    </Button>
                                                </span>
                                            </OverlayTrigger>
                                            }
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )}


                    <div className="text-right mt-10">
                        <Button variant="default" type="button" onClick={onHide} className="mr-2">
                            {readOnly ? 'Cerrar' : 'Cancelar'}
                        </Button>
                        {!readOnly &&
                        <Button variant="primary" type="submit">
                            Actualizar Pedido
                        </Button>
                        }
                    </div>

                </Form>
            </Modal.Body>
        </Modal>
    );
}
